import WaterQualityLists from './WaterQualityLists';

export default WaterQualityLists;
